import { Link } from "react-router-dom";
import { PageTitle } from "../components/site/PageTitle";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";

export default function Services() {
  const { services = [] } = useSite();
  return (
    <div className="pb-20">
      <PageTitle badge="What we offer" title="Services" subtitle="Choose a service below, then start a custom order when you are ready." testId="services-title" flash />
      <div className="mx-auto grid max-w-6xl gap-6 px-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((sv, i) => (
          <div key={sv.id} className="rise panel overflow-hidden border-[#2563EB]/30 transition-transform duration-300 hover:-translate-y-1 hover:border-[#E5202A]/60" style={{ animationDelay: `${i * 80}ms` }} data-testid={`service-card-${sv.id}`}>
            <img src={imgUrl(sv.image)} alt={sv.title} className="aspect-[4/3] w-full object-cover" loading="lazy" />
            <div className="p-6">
              <h3 className="red-title text-2xl">{sv.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300">{sv.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-14 text-center"><Link to="/order" className="btn-red" data-testid="services-start-order-button">Start a Custom Order</Link></div>
    </div>
  );
}
